import { Injectable } from '@angular/core';
import { FeatureState } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import * as fromAnnouncementsActions from '../actions/announcements.actions';
import { CreateAnnouncementDto } from '../dtos/create-announcement-dto.interface';
import { UpdateAnnouncementDto } from '../dtos/update-announcement-dto.interface';
import { IAnnouncementsProvider } from './announcements.provider.interface';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class AnnouncementsProvider implements IAnnouncementsProvider {
    constructor(private store: Store<FeatureState>) {}

    public isStorybook(): boolean {
        //This must always return false!
        return false;
    }

    public dispatchGetAllAnnouncements(): void {
        this.store.dispatch(fromAnnouncementsActions.announcementsActions.getAllAnnouncements());
    }

    public dispatchCreateAnnouncement(announcement: CreateAnnouncementDto): void {
        this.store.dispatch(
            fromAnnouncementsActions.announcementsActions.createAnnouncement({ payload: announcement }),
        );
    }

    public dispatchUpdateAnnouncement(id: string, changes: UpdateAnnouncementDto): void {
        this.store.dispatch(
            fromAnnouncementsActions.announcementsActions.updateAnnouncement({ payload: { id, changes } }),
        );
    }

    public dispatchDeleteAnnouncement(id: string): void {
        this.store.dispatch(fromAnnouncementsActions.announcementsActions.deleteAnnouncement({ payload: id }));
    }

    public dispatchGetUserAnnouncements(): void {
        this.store.dispatch(fromAnnouncementsActions.announcementsActions.getUserAnnouncements());
    }

    public dispatchDismissAnnouncement(announcementId: string): void {
        this.store.dispatch(
            fromAnnouncementsActions.announcementsActions.dismissAnnouncement({ payload: announcementId }),
        );
    }

    public dispatchSetSelectedAnnouncement(announcementId: string | null): void {
        this.store.dispatch(
            fromAnnouncementsActions.announcementsActions.setSelectedAnnouncement({ payload: announcementId }),
        );
    }
}
